/* eslint-disable */
import '../vendor/reviews-embed';

export default {
  init() {
    dropdownWidget('dropdown-640',{
        store: 'express-bi-folds-direct',
        primaryClr: '#f47e27',
        neutralClr: '#f4f4f4',
        textClr: '#000',
        height: 400,
        numReviews: 10,
        direction: 'up',
    });

    dropdownWidget('dropdown-300',{
        store: 'express-bi-folds-direct',
        primaryClr: '#f47e27',
        neutralClr: '#f4f4f4',
        textClr: '#000',
        height: 400,
        numReviews: 10,
        direction: 'down',
    });
  }
}
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/reviews.js